// Mock API for local testing
// Use this to test the frontend without a real backend

export const mockSubmitQuestionnaire = async (formData) => {
  console.log('📋 Mock Submission - Form Data:', formData);
  
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 2000));
  
  // Mock HTML report (sample from your backend)
  const mockHtmlContent = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Medical Report - ${formData.fullName}</title>
    <style>
        body {
            font-family: 'Segoe UI', Arial, sans-serif;
            line-height: 1.6;
            margin: 0;
            padding: 20px;
            color: #2d3748;
            background: white;
        }
        .container {
            max-width: 800px;
            margin: 0 auto;
            background: white;
            border-radius: 12px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.1);
            overflow: hidden;
        }
        .header-section {
            background: linear-gradient(135deg, #2c5282 0%, #3182ce 100%);
            color: white;
            padding: 30px;
            text-align: center;
        }
        .header-section h1 {
            font-size: 28pt;
            margin: 0;
        }
        .content-area {
            padding: 30px;
        }
        .diagnosis-card {
            background: linear-gradient(135deg, #e6fffa 0%, #f0fff4 100%);
            border: 3px solid #38b2ac;
            border-radius: 12px;
            padding: 25px;
            margin: 20px 0;
        }
        .diagnosis-value {
            font-size: 20pt;
            font-weight: 700;
            color: #234e52;
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header-section">
            <h1>🏥 eChestPain Report (PREVIEW)</h1>
            <p>Patient: ${formData.fullName}</p>
            <p>Age: ${formData.age} | Gender: ${formData.gender}</p>
        </div>
        <div class="content-area">
            <div class="diagnosis-card">
                <div class="diagnosis-value">Assessment Complete</div>
                <p>This is a mock preview of your report.</p>
                <p>In production, you'll see the full clinical assessment here.</p>
            </div>
            <h2>Submitted Information:</h2>
            <ul>
                <li><strong>Pain began:</strong> ${formData.painBegin}</li>
                <li><strong>Frequency:</strong> ${formData.frequency}</li>
                <li><strong>Character:</strong> ${formData.characterPain.join(', ')}</li>
                <li><strong>Smoking:</strong> ${formData.smoke}</li>
            </ul>
        </div>
    </div>
</body>
</html>
  `;
  
  // Simulate successful response with HTML content
  return {
    success: true,
    result: {
      html_content: mockHtmlContent,
      html: {
        s3_bucket: 'echestpain',
        s3_key: 'letters/mock_report.html',
        filename: 'mock_report.html',
        size_bytes: mockHtmlContent.length
      },
      processing_time: 0.5,
      patient_name: formData.fullName
    }
  };
};

// You can also simulate errors to test error handling
export const mockSubmitQuestionnaireWithError = async (formData) => {
  console.log('📋 Mock Submission - Form Data:', formData);
  
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Simulate an error
  throw new Error('Unable to process your submission. Please try again later.');
};

// Example test data - use this to quickly fill the form during testing
export const mockFormData = {
  fullName: 'John Smith',
  age: '45',
  gender: 'Male',
  dateOfBirth: '1980-01-15',
  email: 'john.smith@nhs.net',
  painBegin: '2025-11-01',
  frequency: 'daily',
  characterPain: ['tight', 'squeezing'],
  radiate: ['radiates to the left arm'],
  worsenedBy: ['exercise', 'walking up stairs'],
  relievedBy: ['rest from exercise'],
  smoke: 'non-smoker',
  riskFactors: ['high cholesterol', 'hypertension (high blood pressure)']
};

// To use the mock in development:
// 1. Open src/api.js
// 2. At the top, add: import { mockSubmitQuestionnaire } from './mockApi';
// 3. In submitQuestionnaire function, replace the axios call with:
//    return mockSubmitQuestionnaire(formData);
